import {exists, Module} from '@nu-art/ts-common';
import {Default_SyncManagerNodePath, ModuleFE_SyncManager, ModuleFE_XHR} from '@nu-art/thunderstorm-frontend/index';
import {SyncDataFirebaseState} from '@nu-art/thunderstorm-shared/sync-manager/types';
import {ModuleFE_AdvisorSession, ModuleFE_EMInterface, OnAdvisorReset} from '@app/advisor-frontend';
import {ModuleFE_AdvisorSettings} from '@app/advisor-v5-frontend/modules/ModuleFE_AdvisorSettings/ModuleFE_AdvisorSettings';
import {Dialog_ClearEncounter} from '@app/advisor-v5-frontend/ui/menus/Menu_AdvisorSettings/clear-encounter-dialog/Dialog_ClearEncounterDialog';

class ModuleFE_AppModule_Class
	extends Module
	implements OnAdvisorReset {

	private firstLaunchCompleted?: boolean;

	__onAdvisorReset() {
		this.firstLaunchCompleted = false;
	}

	protected init() {
		super.init();


		// set sync manager dynamic resolvers
		ModuleFE_SyncManager.setNodeContext(() => {
			const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();

			if (!encounterId)
				return Default_SyncManagerNodePath;

			return `/state/DataSyncManager/${encounterId}/syncData`;
		});

		ModuleFE_SyncManager.setOnSyncCompleted(this.isAppLoading); // app will stop being busy only when sync is completed
		ModuleFE_SyncManager.setOnSyncDataChanged(this.isLoadingInitialData); // this process might end beforehand

		// advisor must sync faster
		ModuleFE_SyncManager.setDebounceTimeout(500);
		ModuleFE_SyncManager.setDebounceMaxTimeout(1500);

		ModuleFE_SyncManager.setSmartSyncUrl(`${ModuleFE_XHR.getOrigin()}/data-sync-manager/smart-sync`);
		ModuleFE_SyncManager.setOnSmartSyncError(async (err) => {
			switch (err.responseCode) {
				case 401: {
					ModuleFE_SyncManager.stopListening();
					Dialog_ClearEncounter.show('Session has expired!');
					break;
				}
				case 410: {
					//Initiate app clean-up as if user has cleared encounter
					ModuleFE_SyncManager.stopListening();
					await ModuleFE_AdvisorSettings.clearEncounterCache(ModuleFE_AdvisorSession.getCurrentEncounterId());
					Dialog_ClearEncounter.show('Encounter was cleared remotely!');
					break;
				}
			}
		});
	}

	private isAppLoading = (syncData: SyncDataFirebaseState | undefined) => {
		this.logDebug('Got sync data', syncData);
		if (!exists(syncData))
			return;

		if (ModuleFE_EMInterface.isAvatarMode() || this.firstLaunchCompleted)
			return;

		// mark first launch completed in memory and get the available protocols
		this.firstLaunchCompleted = true;
		ModuleFE_EMInterface.vv1.protocols.getAvailableProtocols().execute();
	};

	private isLoadingInitialData = (syncData: SyncDataFirebaseState | undefined) => {
		if (!syncData)
			return;

		this.logDebug('sync data updated', syncData);
		const _syncData = syncData as SyncDataFirebaseState & { loadingInitialData: boolean };
		if (exists(_syncData?.loadingInitialData))
			ModuleFE_EMInterface.setLoadingInitialData(_syncData.loadingInitialData);
	};
}

export const ModuleFE_AppModule = new ModuleFE_AppModule_Class();